import { getKbGroupId } from './kbGroupId';

/** Business public tenant = business detail slug (stable); only group_id changes per group. */
export const normalizeBusinessSlug = (slug) =>
  String(slug || '')
    .trim()
    .toLowerCase();

export const selectBusinessSlug = (state) =>
  state?.workspaceSettings?.data?.slug || null;

/**
 * Build public help-center URL.
 * Tenant = business detail `slug` (e.g. trustchat). Pass current `group_id` for that group’s KB.
 */
export const buildExternalKbUrl = ({
  slug,
  articleId,
  groupId,
  path = '',
} = {}) => {
  const tenant = normalizeBusinessSlug(slug);
  if (!tenant) return null;

  const resolvedGroupId = groupId || getKbGroupId();
  const groupQuery = resolvedGroupId
    ? `group_id=${encodeURIComponent(resolvedGroupId)}`
    : '';

  const cleanPath = path
    ? path.startsWith('/')
      ? path
      : `/${path}`
    : '';
  const articlePath = articleId ? `/${articleId}` : cleanPath;

  if (process.env.NODE_ENV === 'production') {
    const query = groupQuery ? `?${groupQuery}` : '';
    return `https://${tenant}.trustchat.com/kb/view${articlePath}${query}`;
  }

  const params = [`tenant=${encodeURIComponent(tenant)}`];
  if (groupQuery) params.push(groupQuery);
  return `${window.location.origin}/kb/view${articlePath}?${params.join('&')}`;
};
